<template>
  <md-list-item v-if="isVisible" class="md-inset" @click="navigate">
    <slot></slot>
  </md-list-item>
</template>

<script>
import { mapGetters } from 'vuex'
import roles from '@/utils/roles.js'

export default {
  name: 'menu-role-item',
  props: {
    route: String,
    toggle: {
      type: Boolean,
      default: true
    },
    isPublic: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('Auth', ['role', 'isGlobalAdmin']),
    isVisible() {
      if (this.isPublic) {
        return this.toggle
      }

      let module = roles.getResponsibleModule(this.route)
      var routeReplaced = this.route
      routeReplaced = routeReplaced.substring(module.length + 1, routeReplaced.length);
      return this.toggle && roles.showRoute(module, routeReplaced, this.role, this.isGlobalAdmin)
    }
  },
  methods: {
    navigate(){
      this.$router.push(this.route)
      this.$parent.$parent.$parent.$emit('navigateMobile')
    }

  }
}
</script>
